import(/* webpackMode: "eager", webpackExports: ["CoursesCatalog"] */ "/vercel/path0/src/features/courses/components/courses-catalog.tsx");
